import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function ViewEvents() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [events, setEvents] = useState(null);
    const [loading, setLoading] = useState(false);
    const savedUser = JSON.parse(localStorage.getItem('user'));
    const [user, setUser] = useState(null);

    useEffect(() => {
        setLoading(true);

        const fetchEvents = async () => {
            try {
                const response = await axios.get(`https://geoid-rest.vercel.app/events/${id}`);
                setEvents(response.data);
            } catch (error) {
                console.error('Error fetching media:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchEvents();
    }, [id]);

    useEffect(() => {
        setLoading(true);

        const fetchEvents = async () => {
            try {
                const response = await axios.get(`https://geoid-rest.vercel.app/users/${savedUser.user._id}`);
                setUser(response.data);
            } catch (error) {
                console.error('Error fetching user:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchEvents();
    }, [id]);

    useEffect(() => {
        setLoading(true);

        const fetchEvents = async () => {
            try {
                const response = await axios.get(`https://geoid-rest.vercel.app/events/${id}`);
                setEvents(response.data);
            } catch (error) {
                console.error('Error fetching media:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchEvents();
    }, [id]);

    if (loading) {
        return <div className="loading-screen"><p>Loading event...</p></div>;
    }

    if (!events) {
        return <div>No events found.</div>;
    }

    return(
        <div style={{
            width: '100%', 
            display: 'flex', 
            justifyContent: "space-evenly", 
            flexDirection: "row",
            alignItems: "center"
        }}>
            <div className="event-container">
                {events.type === "video" ? (
                    <video controls src={events.imgSrc} className="media-player" />
                ) : (
                    <div className="image-wrapper"> {/* Open viewer on click */}
                        <img src={events.imgSrc} alt={events.name} className="media-image" />
                        {/* <div className="media-overlay">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-zoom-in" viewBox="0 0 16 16">
                                <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11M13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0"/>
                                <path d="M10.344 11.742q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1 6.5 6.5 0 0 1-1.398 1.4z"/>
                                <path fill-rule="evenodd" d="M6.5 3a.5.5 0 0 1 .5.5V6h2.5a.5.5 0 0 1 0 1H7v2.5a.5.5 0 0 1-1 0V7H3.5a.5.5 0 0 1 0-1H6V3.5a.5.5 0 0 1 .5-.5"/>
                            </svg>
                            <span>Click for Fullscreen</span>
                        </div> */}
                    </div>
                )}
            </div>
            <div className="event-details">
                <h2>{events.title}</h2>
                <p><strong>Organizer:</strong> {events.organizer || "-"}</p>
                <p><strong>Speaker's Name:</strong> {events.speakerName || "-"}</p>
                <p><strong>Agenda / Info of Event:</strong> {events.agenda || "-"}</p>
                <p><strong>Date:</strong> {new Date(events.date).toLocaleDateString('en-GB')}</p>
                <p><strong>Time:</strong> { 
                    isNaN(new Date(`1970-01-01T${events.startTime}:00`)) ? "Invalid Time" : new Date(`1970-01-01T${events.startTime}:00`).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) 
                } - { 
                    isNaN(new Date(`1970-01-01T${events.endTime}:00`)) ? "Invalid Time" : new Date(`1970-01-01T${events.endTime}:00`).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) 
                }</p>
                <p><strong>Venue:</strong> {events.venue.toUpperCase()}</p>
                <p><strong>Price:</strong></p>
                {events.prices && events.prices.map((price, index) => (
                    <p key={index} style={{marginLeft: '20px'}}>
                        {price.type} - RM{price.amount}
                    </p>
                ))}
                <div className='button-group'>
                    <button 
                        className="view-model-btn" 
                        onClick={() => {
                            const userEvents = user.events || [];
                            const isRegistered = userEvents.some(event => event.eventId === id);

                            if (isRegistered) {
                                toast.info("You have already registered for this event.");
                            } else {
                                navigate(`/registerEvents/${id}`);
                            }
                        }}
                    >
                        Proceed
                    </button>
                    {/* <button className="download-model-btn" onClick={handlePurchaseClick}>Purchase</button>
                    {purchasedMedia.includes(media._id) ? (
                        <a href={media.imgSrc} download style={{textDecoration: 'none'}}><button className="download-model-btn">Download Media</button></a>
                    ): null} */}
                </div>
            </div>

            <ToastContainer />
        </div>
    )
}

export default ViewEvents;